export default __webpack_public_path__ + "static/nspp-sponsor-Accad-93dbb9e85cdd23647276d84711e921c8.png";